<template>
  <div class="page-content">
     <div class="container-fluid">
        <!-- start page title -->
        <div class="row">
           <div class="col-12">
              <div class="page-title-box d-flex align-items-center justify-content-between">
                 <h4 class="mb-0 font-size-18">View Ticket</h4>
                 <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                       <li class="breadcrumb-item"><a href="javascript: void(0);">Tickets</a></li>
                       <li class="breadcrumb-item active">View Ticket</li>
                    </ol>
                 </div>
              </div>
           </div>
        </div>
        <!-- end page title -->
        <div class="row" v-if="ticket.status == 'Closed'">
          <div class="col-md-12 pull-md-right main-content">
            <div class="alert alert-warning text-center">
              This ticket is closed.  You may reply to this ticket to reopen it
            </div>
        </div>
      </div>
        <div class="row">
           <div class="col-12">
              <div class="card">
                 <div class="card-body">
                    <div class="page-title-box d-flex align-items-center justify-content-between">
                       <h5 class="mb-0 font-size-15">Ticket Information</h5>
                    </div>
                    <div class="table-responsive">
                       <table class="table table-centered table-nowrap">
                          <thead class="thead-light">
                             <tr>
                                <th>Ticket #</th>
                                <th>Department</th>
                                <th>Subject</th>
                                <th>Last Updated</th>
                                <th>Status</th>
                                <th>Action</th>
                             </tr>
                          </thead>
                          <tbody>
                             <tr>
                                <td> {{ ticket.id }} </td>
                                <td>{{ ticket.department }}</td>
                                <td>
                                  {{ ticket.subject }}
                                </td>
                                <td>
                                   {{ ticket.lastUpdated }}
                                </td>
                                <td>
                                   <span :class="statusClass">{{ ticket.status }}</span>
                                </td>
                                <td>
                                   <!-- Button trigger modal -->
                                   <button type="button" class="btn btn-danger btn-sm btn-rounded" v-on:click="closeTicket" :disabled="ticket.status == 'Closed' ? true : false">
                                   Close Ticket
                                   </button>
                                </td>
                             </tr>
                          </tbody>
                       </table>
                    </div>
                 </div>
              </div>
           </div>
        </div>
        <!--end of row-->
        <div class="row">
           <div class="col-12">
              <div class="card">
                 <div class="card-body">
                    <div id="accordion">
                       <div class="card mb-1 shadow-none">
                          <a href="#reply" class="text-dark" data-toggle="collapse"
                             aria-expanded="true"
                             aria-controls="collapseOne">
                             <div class="card-header" id="headingOne">
                                <h6 class="m-0">
                                   <i class=" bx bx-plus"></i>
                                   Reply to Ticket
                                </h6>
                             </div>
                          </a>
                          <div id="reply" class="collapse"
                             aria-labelledby="headingOne" data-parent="#accordion">
                             <div class="card-body">
                                <div class="col-lg-12">
                                   <h4 class="card-title mb-4">Reply</h4>
                                   <form class="outer-repeater">
                                      <div data-repeater-list="outer-group" class="outer">
                                         <div data-repeater-item class="outer">
                                            <div class="form-group">
                                               <label for="formmessage">Message :</label>
                                               <textarea v-model="message" id="formmessage" class="form-control" rows="4"></textarea>
                                            </div>
                                            <button v-on:click="replyTicket" class="btn btn-primary">Submit</button>
                                         </div>
                                      </div>
                                   </form>
                                </div>
                             </div>
                          </div>
                       </div>
                    </div>
                 </div>
              </div>
           </div>
           <!-- end Col-9 -->
        </div>
        <!-- end row -->
        <div class="row" v-bind:key="reply" v-for="reply in ticket.responses">
           <div class="col-12">
              <!-- Right Sidebar -->
              <div class="col-12">
                 <div class="card">
                    <div class="card-body">
                       <div class="media mb-4">
                          <img class="d-flex mr-3 rounded-circle avatar-sm" src="../../../assets/images/users/avatar-1.jpg" alt="Generic placeholder image">
                          <div class="media-body">
                             <h5 class="font-size-14 mt-3">{{ reply.name || reply.admin}}</h5>
                             <small class="text-muted" v-if="reply.name != ''">Client</small>
                             <small class="text-muted" v-else>Support Manager</small>
                          </div>
                       </div>
                       <p>
                          {{ reply.message }}
                       </p>
                       <hr/>
                       <!--<p style="text-alignL left">IPs Address: 32.672.13.257</p>-->
                       <p style="text-align: right">{{ reply.date }}</p>
                    </div>
                 </div>
              </div>
              <!-- card -->
           </div>
           <!-- end Col-9 -->
        </div>
        <!-- end row -->
        <!-- end row -->
     </div>
  </div>
</template>

<script>
import store from '../../../store'
export default{
  name: 'ViewTicket',
  data () {
    return { ticket: {}, message: '' }
  },
  created () {
    this.getTicket()
  },
  computed: {
    statusClass: function () {
      var baseClass = 'badge badge-pill font-size-12 '
      switch (this.ticket.status) {
        case 'Open':
          baseClass += 'badge-success'
          break
        case 'Answered':
          baseClass += 'badge-light'
          break
        case 'Customer-Reply':
          baseClass += 'badge-warning'
          break
        case 'On Hold':
          baseClass += 'badge-danger'
          break
        case 'In Progress':
          baseClass += 'badge-info'
          break
        case 'Closed':
          baseClass += 'badge-secondary'
          break
        default:
          baseClass += 'badge-light'
      }
      return baseClass
    }
  },
  methods: {
    getTicket: function () {
      let ticketId = this.$route.params.id || -1
      fetch(store.state.url + '/support/ticket/' + ticketId + '/view', {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + store.state.token
        }
      }).then(response => {
        return response.json()
      }).then(data => {
        var ticketData = data
        var responseData = ticketData.responses.sort((a, b) => new Date(b.date) - new Date(a.date))
        ticketData['responses'] = responseData
        this.ticket = ticketData
      }).catch(err => {
        console.error(err)
      })
    },
    replyTicket: function (e) {
      e.preventDefault(true)
      let ticketId = this.$route.params.id || -1
      let data = new URLSearchParams()
      data.set('message', this.message)
      fetch(store.state.url + '/support/ticket/' + ticketId + '/reply', {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + store.state.token
        },
        body: data
      }).then(response => {
        return response.json()
      }).then(data => {
        this.message = ''
        this.getTicket()
      }).catch(err => {
        console.error(err)
      })
    },
    closeTicket: function (e) {
      e.preventDefault()
      let ticketId = this.$route.params.id || -1
      fetch(store.state.url + '/support/ticket/' + ticketId + '/close', {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + store.state.token
        }
      }).then(response => {
        return response.json()
      }).then(data => {
        this.getTicket()
      }).catch(err => {
        console.error(err)
      })
    }
  }
}</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/management/support/ViewTicket.vue